var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgLogoPart2Button(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 96,
    viewBox: "0 0 221 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83528 35.9683L7.54143 18.6784C105.185 6.94501 193.053 -32.5473 193.926 -32.9441L220.22 -13.4795C219.869 -12.8554 184.673 51.7511 179.628 142.955L145.845 152.392C142.279 136.427 144.088 114.98 144.438 112.162C149.731 69.8156 160.367 34.7916 169.516 10.6307C141.772 20.6083 102.615 32.9537 58.5827 41.6841C62.0701 43.6997 65.1591 45.5282 67.7763 47.1403C78.3104 45.0966 94.5304 41.7882 122.506 33.4077L147.142 51.3852C146.938 52.0119 133.374 93.4566 134.846 142.235C122.242 130.205 109.598 119.344 97.3916 109.652C98.089 96.0266 99.6567 82.6123 102.671 71.1962C83.1702 76.1387 67.4515 79.141 57.1799 80.4362C27.6077 60.8257 5.52176 50.101 0.914734 47.9243C0.536245 47.6138 0.260416 47.3865 0.0871552 47.2423L2.84222 35.9663L2.83528 35.9683Z",
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLogoPart2Button);
export default __webpack_public_path__ + "static/media/bgLogoPart2_button.35cd3fd15e2bbef6095c97f8b1d61bb8.svg";
export { ForwardRef as ReactComponent };